import jwtDecode from 'jwt-decode';
import { fetch } from '~actions/pms-actions/shared';
import { pmsEndpoints } from '~settings/endpoints';
import cookies from 'js-cookie';
import * as queries from '~settings/pms-queries';
import { cookieNames, accountSortByMapping, sortDirectionMapping } from '~constants';
import { message } from 'antd';
import i18n from '~settings/i18n';
import { formatSimpleParams } from '~helpers/params';
import { accountActionTypes as actions } from '~constants/actionTypes';

export const setLandlordUser = payload => ({
  type: actions.SET_CMS_USER,
  payload: payload.landlordContact,
});

export const getLandlordList =
  (onSuccess = () => {}) =>
  dispatch => {
    const query = queries.searchLandlordList({
      pageNumber: 1,
      pageSize: 9999,
      query: '',
    });
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getLandlordList.url(),
      params: query,
      communicationType: actions.LANDLORD_LIST_CS,
      onSuccess: res => {
        onSuccess(res);
      },
    });
  };

export const getLandlordUser =
  (onSuccess = () => {}) =>
  dispatch => {
    const utoken = cookies.get(cookieNames.token);

    try {
      const info = jwtDecode(utoken);
      if (info && info.uuid) {
        fetch({
          dispatch,
          endpoint: pmsEndpoints.getGeneralUrl.url(),
          params: queries.getLandlordUser({ userUuid: info.uuid }),
          communicationType: actions.GET_LANDLORD_USER_CS,
          onSuccess: res => {
            onSuccess(res);
          },
          successAction: setLandlordUser,
        });
      } else {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      }
    } catch (error) {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    }
  };

export const createAccount = params => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.getGeneralUrl.url(),
    params: queries.createAccount(
      formatSimpleParams(
        {
          email: null,
          firstName: null,
          landlordId: null,
          lastName: null,
          password: null,
          roles: [],
          signupType: null,
        },
        params,
      ),
    ),
    communicationType: actions.CREATE_CS,
    onError: () => {
      message.error(i18n.t('cms:cms.account.create_error.tips'));
    },
    onSuccess: () => {
      message.success(i18n.t('cms:cms.account.create_success.tips'));
    },
  });
};

export const updateAccount =
  (params, onSuccess = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.getGeneralUrl.url(),
      params: queries.updateAccount(params),
      communicationType: actions.UPDATE_CS,
      onError: () => {
        message.error(i18n.t('cms:cms.account.update_error.tips'));
      },
      onSuccess: res => {
        message.success(i18n.t('cms:cms.account.update_success.tips'));
        onSuccess(res);
      },
    });
  };

export const setUserList = payload => ({
  type: actions.SET_LIST,
  payload: payload.cmsUsers,
});

export const getUserList = params => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.getGeneralUrl.url(),
    params: queries.cmsUsers(
      formatSimpleParams(
        {
          pageNumber: 1,
          pageSize: 999,
          landlordSlugs: null,
          sortBy: accountSortByMapping.updatedAt,
          sortDirection: sortDirectionMapping.descend,
        },
        params,
      ),
    ),
    communicationType: actions.LIST_CS,
    successAction: setUserList,
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
  });
};
